import { useForm } from 'react-hook-form';
import type { TSupervisorAdministrationFormValues } from './types.ts';
import { buildSupervisorAdministrationFormValues } from './utils.ts';

const useSupervisorAdministrationForm = () =>
  useForm<TSupervisorAdministrationFormValues>({
    defaultValues: buildSupervisorAdministrationFormValues(),
    mode: 'onTouched',
  });

export default useSupervisorAdministrationForm;
